import { Match, Show, Switch } from 'solid-js';
import { useMachine } from '@xstate/solid';
import { applicationMachine } from '@academy/machines';
import { Button, Notice } from '@academy/ui';
import { loadBootstrap, refreshBootstrap } from './services/supabase';
import { SessionProvider } from './context/session';
import { AuthPage } from './routes/AuthPage';
import { WorkspaceRouter } from './routes/WorkspaceRouter';
import styles from './app.module.css';

export const App = () => {
  const [snapshot, send] = useMachine(applicationMachine, {
    input: { load: loadBootstrap },
  });

  return (
    <Switch>
      <Match when={snapshot.matches('booting')}>
        <main id="main-content" class={styles.centered} tabindex="-1" aria-busy="true">
          <div class={styles.brandMark} aria-hidden="true">
            V
          </div>
          <p>Opening your academy workspace…</p>
        </main>
      </Match>
      <Match when={snapshot.matches('failed')}>
        <main id="main-content" class={styles.centered} tabindex="-1">
          <Notice tone="error" title="The academy could not be opened">
            <p>{snapshot.context.error ?? 'Check the local services and try again.'}</p>
            <Button onClick={() => send({ type: 'RETRY' })}>Try again</Button>
          </Notice>
        </main>
      </Match>
      <Match when={snapshot.matches('unauthenticated')}>
        <AuthPage />
      </Match>
      <Match when={snapshot.matches('authenticated')}>
        <Show when={snapshot.context.session}>
          {(session) => (
            <SessionProvider
              value={session()}
              refreshCapabilities={() => refreshBootstrap(new AbortController().signal)}
              listenForInvalidations
            >
              <WorkspaceRouter />
            </SessionProvider>
          )}
        </Show>
      </Match>
    </Switch>
  );
};
